<template>
</template>

<script>
	import VueTypes from "vue-types"
	import { commit } from "vuex-pathify"

	export default {
		props: {
			norms: VueTypes.arrayOf(VueTypes.string).def([]),
		},
		mounted(){
			commit("normData/CHANGE_NORMS", this.norms);
		},
	}
</script>